import { render, staticRenderFns } from "./AmwayPay.vue?vue&type=template&id=61b02709&scoped=true&"
import script from "./AmwayPay.vue?vue&type=script&lang=js&"
export * from "./AmwayPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b02709",
  null
  
)

export default component.exports